import React, { Component } from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import postHogFunctions from '~/Classes/posthog';
import i18n from '~/i18n';
@connect((store) => {
    return { user: store.user, account: store.accountMaster, siteMaster: store.siteMaster, permissionStore: store.permission }
})

class DowngradeToFree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            really: "",
            reallyError: "",
            reason: "",
            downgradeAnswer: ""
        }
        this.goDownGrade = this.goDownGrade.bind(this);
    }

    getDowngradeQuestions() {
        return [
            { value: "costSaving", label: i18n.t('company:downgrade.reasons.costSaving') },
            { value: "fewerFeatures", label: i18n.t('company:downgrade.reasons.fewerFeatures') },
            { value: "valueForMoney", label: i18n.t('company:downgrade.reasons.valueForMoney') },
            { value: "betterAlternative", label: i18n.t('company:downgrade.reasons.betterAlternative') },
            { value: "tempBudgetConstraint", label: i18n.t('company:downgrade.reasons.tempBudgetConstraint') },
            { value: "missingFeatures", label: i18n.t('company:downgrade.reasons.missingFeatures') },
            { value: "noTimeToUse", label: i18n.t('company:downgrade.reasons.noTimeToUse') },
            { value: "dontKnowHowToUse", label: i18n.t('company:downgrade.reasons.dontKnowHowToUse') },
            { value: "poorSupport", label: i18n.t('company:downgrade.reasons.poorSupport') },
            { value: "badUi", label: i18n.t('company:downgrade.reasons.badUi') },
            { value: "other", label: i18n.t('company:downgrade.reasons.other') }
        ]
    }

    goDownGrade() {
        var self = this;
        if (!this.state.really || this.state.really.toLowerCase() != "really cancel") {
            this.setState({ reallyError: i18n.t('company:downgrade.confirmError') })
            return;
        }
        this.setState({ reallyError: "" })

        postHogFunctions.capture('plan_downgrade_to_free');

        axios.put('/accountMaster/plan/cancel', { notes: this.state.reason, reason: this.state.downgradeAnswer }).then(_res => {
            self.props.close(true);
        })
    }

    render() {
        if (this.props.currentlyFree) return <>
            <div className="mar-b25 text-heavy">{i18n.t('company:downgrade.currentlyFree')}</div>
            <div className="mar-b25">{i18n.t('company:downgrade.freeReset', { days: this.props.daysLeft })}</div>

        </>

        if (this.props.nextFree) return <>
            <div className="mar-b25 text-heavy">{i18n.t('company:downgrade.alreadyMovingFree')}</div>
            <div className="mar-b25">{i18n.t('company:downgrade.alreadyMovingFreeDesc', { days: this.props.daysLeft })}</div>

        </>

        return (
            <div>
                <div className="mar-b25 text-heavy">{i18n.t('company:downgrade.cancelTitle')}</div>
                <div className="mar-b25">{i18n.t('company:downgrade.cancelDesc', { days: this.props.daysLeft })}</div>

                <div style={{ width: "100%", maxWidth: "700px" }}>
                    <Select
                        className="mar-b25"
                        label={i18n.t('company:downgrade.reasonLabel')}
                        data={this.getDowngradeQuestions()}
                        value={this.state.downgradeAnswer}
                        onChange={(ev) => { this.setState({ downgradeAnswer: ev.target.value }) }}
                    />

                    {this.state.downgradeAnswer && <>
                        <TextArea outerClassName="mar-b25" label={i18n.t('company:downgrade.detailsLabel')} value={this.state.reason}
                            onChange={ev => this.setState({ reason: ev.target.value })} />

                        <TextInput outerClassName="mar-b25" label={i18n.t('company:downgrade.confirmLabel')} name="really" value={this.state.really} onChange={(event) => { this.setState({ really: event.target.value }) }} error={this.state.reallyError} />


                        <div className="quickFlex">
                            <Button className="button-red" text={i18n.t('company:downgrade.cancelButton')} disabled={!this.state.really || this.state.really.toLowerCase() != "really cancel"} onClick={this.goDownGrade} />
                        </div>


                    </>}
                </div>


            </div >
        );
    }
}

export default DowngradeToFree;
